// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries



// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBvtxuUCzc5vN6A-mNUl2khnGEib5K7h-w",
  authDomain: "ipod-react-c473f.firebaseapp.com",
  projectId: "ipod-react-c473f",
  storageBucket: "ipod-react-c473f.appspot.com",
  messagingSenderId: "244740859939",
  appId: "1:244740859939:web:1a7f761ac08c1895956996"
};
const app = initializeApp(firebaseConfig);

export default app;